import { useState, useCallback, useEffect } from 'react'
import { BroadcastChannel } from 'broadcast-channel'

import {CHANNEL_MESSAGE, CHANNEL_NAME} from '../config'


const useBroadcastChannel = (callback) => {
  const [message, setMessage] = useState(null)

  const showMessage = useCallback(() => {
    if (message) {
      callback(message)
    }
  }, [message, callback])

  const _openBroadcastChannel = useCallback(() => {
    const _bc_support = 'BroadcastChannel' in window
    return _bc_support ? new window.BroadcastChannel(CHANNEL_NAME) : new BroadcastChannel(CHANNEL_NAME)
  }, [])

  // Listens to the broadcast channel and triggers the callback
  useEffect(() => {
    _openBroadcastChannel().onmessage = (event_or_data) => {
      const _bc_support = 'BroadcastChannel' in window
      const _d = _bc_support ? event_or_data.data : event_or_data
      const _m = {
        ...CHANNEL_MESSAGE,
        ..._d,
      }
      setMessage(_m)
    }
  }, [_openBroadcastChannel])

  return [message, showMessage]
}

export default useBroadcastChannel
